import { NewsFeedCard } from '@/components/news/NewsFeedCard';
import { BreakingTicker } from '@/components/news/BreakingTicker';
import { CategoryRail } from '@/components/news/CategoryRail';
import { Seo } from '@/components/seo/Seo';
import { useInfiniteFeed } from '@/hooks/useInfiniteFeed';
import { appConfig } from '@/config/app';
import { getBreakingNews, getCategorySummaries, getPublishedNews } from '@/services/newsRepository';

export function HomePage() {
  const articles = getPublishedNews();
  const { visibleItems, sentinelRef, hasMore } = useInfiniteFeed(articles, 3);

  return (
    <>
      <Seo
        title="El Divergente"
        description="Feed de noticias de Puerto San Julian en una experiencia movil."
        canonical={appConfig.siteUrl}
        keywords={['Puerto San Julian', 'Santa Cruz', 'noticias']}
        image={articles[0]?.hero.url}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'NewsMediaOrganization',
          name: appConfig.name,
          url: appConfig.siteUrl,
          areaServed: appConfig.region
        }}
      />
      <BreakingTicker articles={getBreakingNews()} />
      <CategoryRail categories={getCategorySummaries()} />
      <section className="snap-y snap-mandatory scroll-smooth">
        {visibleItems.map((article) => (
          <NewsFeedCard key={article.id} article={article} />
        ))}
        <div ref={sentinelRef} className="grid h-24 place-items-center text-sm text-white/38">
          {hasMore ? 'Cargando más' : 'Fin del feed'}
        </div>
      </section>
    </>
  );
}
